'use client';

import { useTranslation } from 'next-i18next';
import { LinkStyled } from '@components/common';

/**
 * @description Offer Page Book Demo banner - displayed between services and bundles
 */
export const OfferPageBookDemoBanner = () => {
  const { t } = useTranslation('common');

  return (
    <div>
      <div className="flex flex-col items-center justify-between py-2 md:flex-row">
        <h2 className="text-lg font-bold">{t('screening.book.demo.info')}</h2>

        <LinkStyled
          size="sm"
          color="secondary"
          styling="solid"
          rounding="full"
          href="https://calendar.app.google/yxjBid19WVKRaYDr8"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('screening.book.demo')}
        </LinkStyled>
      </div>
    </div>
  );
};
